import Flex from '@utilities/components/Layout/components/Flex';

import NarrativesCanvas from './components/NarrativesCanvas';

import styles from './_index.module.scss';

const NarrativesChat = () => {
  return (
    <Flex className={styles['narratives-chat-wrapper']} gap="none">
      <div className={styles['narratives-chat-window']}>TOOL/CHAT WINDOW</div>
      <NarrativesCanvas />
    </Flex>
  );
};

export default NarrativesChat;
